import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=027de4c2&scoped=true&"
import script from "./InformationCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InformationCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=027de4c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027de4c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027de4c2')) {
      api.createRecord('027de4c2', component.options)
    } else {
      api.reload('027de4c2', component.options)
    }
    module.hot.accept("./InformationCard.vue?vue&type=template&id=027de4c2&scoped=true&", function () {
      api.rerender('027de4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuInformation/components/InformationCard.vue"
export default component.exports